import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

// (S)CSS
import 'primevue/resources/themes/tailwind-light/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import '~/assets/css/tailwind.css';
import '~/assets/scss/style.scss';
import 'primeflex/primeflex.css';

// Components
import Button from "~/components/Button.vue";
Vue.component('Button', Button)

// PrimeVue
import PrimeVue from 'primevue/config';

import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import PButton from "primevue/button";
import SelectButton from 'primevue/selectbutton';
import Chip from 'primevue/chip';
import Tag from 'primevue/tag';
import Avatar from 'primevue/avatar';
import TabMenu  from 'primevue/tabmenu';
import Sidebar from 'primevue/sidebar';
import InputText from 'primevue/inputtext';
import InputSwitch from 'primevue/inputswitch';
import Dropdown from 'primevue/dropdown';
import ToggleButton from 'primevue/togglebutton';
import ColorPicker from 'primevue/colorpicker';
import SpeedDial from 'primevue/speeddial';
import Message from 'primevue/message';
import Chips from 'primevue/chips';
import Textarea from 'primevue/textarea';
import Calendar from 'primevue/calendar';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmDialog from 'primevue/confirmdialog';
import AvatarGroup from 'primevue/avatargroup';
import ScrollPanel from 'primevue/scrollpanel';
import Checkbox from 'primevue/checkbox';
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import AutoComplete from 'primevue/autocomplete';
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import Skeleton from 'primevue/skeleton';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';

Vue.component('PButton', PButton);
Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('SelectButton', SelectButton);
Vue.component('Chip', Chip);
Vue.component('Tag', Tag);
Vue.component('Avatar', Avatar);
Vue.component('TabMenu', TabMenu);
Vue.component('Sidebar', Sidebar);
Vue.component('InputSwitch', InputSwitch);
Vue.component('InputText', InputText);
Vue.component('Dropdown', Dropdown);
Vue.component('ToggleButton', ToggleButton);
Vue.component('ColorPicker', ColorPicker);
Vue.component('SpeedDial', SpeedDial);
Vue.component('Message', Message);
Vue.component('Dialog', Dialog);
Vue.component('Toast', Toast);
Vue.component('Chips', Chips );
Vue.component('Textarea', Textarea );
Vue.component('Calendar', Calendar );
Vue.component('ConfirmPopup', ConfirmPopup);
Vue.component('ConfirmDialog', ConfirmDialog);
Vue.component('Checkbox', Checkbox);
Vue.component('Splitter', Splitter);
Vue.component('SplitterPanel', SplitterPanel)
Vue.component('Skeleton', Skeleton);

Vue.use(PrimeVue);
Vue.use(ConfirmationService);
Vue.use(ToastService);

Vue.component('AvatarGroup', AvatarGroup);
Vue.component('ScrollPanel', ScrollPanel);
Vue.component('Dialog', Dialog);
Vue.component('AutoComplete', AutoComplete);
// External Script Import
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);
Vue.component('Toast', Toast);
Vue.use(ToastService);

// Skeleton loader
import VueSkeletonLoader from 'skeleton-loader-vue';
Vue.use(VueSkeletonLoader);

// Palette
import Card from 'primevue/card';


Vue.component('Card', Card);

Vue.prototype.palette = {
  primary: "#56CCF2",
  secondary: "#868BF4",
  red: "#DC582A",
  green: "#64D87E",
  yellow: "#FFC845",
  dark: "#22272B",
  light: "#F7FAFC",
  black: "#181818",
  white: "#FFFFFF",
};

// Plugins
import "~/plugins/vue-mdijs";
import "~/plugins/v-tooltip";
import "~/plugins/vue-js-modal";

Vue.prototype.$dark = function f(dark = false) {
  const bodyClass = document.body.classList;

  if (dark) {
    bodyClass.replace("light-theme", "dark-theme");
  } else {
    bodyClass.replace("dark-theme", "light-theme");
  }
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
